import { render, staticRenderFns } from "./CollectionButton.vue?vue&type=template&id=06490f11&"
import script from "./CollectionButton.vue?vue&type=script&lang=js&"
export * from "./CollectionButton.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports